import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";


export async function getEnums() {
    return await apiRequest({
        url: API_PATHS.getEnums,
        method: "GET",
    });
}

export async function getConfigs() {
    return await apiRequest({
        url: API_PATHS.getConfigs,
        method: "GET",
    });
}

export async function getRules(filters) {
    return await apiRequest({
        url: API_PATHS.getRules(filters),
        method: "GET",
    });
}

export async function createRule(data) {
    return await apiRequest({
        url: API_PATHS.createRule,
        method: "POST",
        data
    });
}
export async function updateRule(id, data) {
    return await apiRequest({
        url: API_PATHS.getRuleById(id),
        method: "PUT",
        data
    });
}
export async function updateRuleState(id, state) {
    return await apiRequest({
        url: API_PATHS.updateRule(id, state),
        method: "PUT",
    });
}

export async function getRuleById(id) {
    return await apiRequest({
        url: API_PATHS.getRuleById(id),
        method: "GET"
    });
}

export async function deleteRuleById(id) {
    return await apiRequest({
        url: API_PATHS.getRuleById(id),
        method: "DELETE"
    });
}

export async function UpdateRules(data, status) {
    return await apiRequest({
        url: API_PATHS.updateRules(status),
        method: "POST",
        data
    });
}

export async function deleteRules(data) {
    return await apiRequest({
        url: API_PATHS.deleteRules,
        method: "DELETE",
        data
    });
}

export async function masterDisable(data, masterDisableValue) {
    return await apiRequest({
        url: API_PATHS.masterDisable(masterDisableValue),
        method: "PUT",
        data
    });
}
export async function getGitDiff(ruleId) {
    return await apiRequest({
        url: API_PATHS.getGitDiff(ruleId),
        method: "GET",
        headers: {
            Accept: "text/plain"
        }
    });
}

export async function getAttributesMetaData() {
    return await apiRequest({
        url: API_PATHS.getAttributesMetaData,
        method: "GET"
    });
}

export async function getUserProfile() {
    return await apiRequest({
        url: API_PATHS.getUserProfile,
        method: "GET"
    })
}

